import { useState } from "react";
import { Kpi } from "@acto/taskpane/core/domain";

export type OrdersList = "orders" | "productGroups";

/** Choosing the orders KPI from another KPI resets the orders list to "productGroups" unless `ordersList` is given. */
export type KpiChange = (kpi: Kpi, options?: { ordersList?: OrdersList }) => void;

export function useCustomerKpiSelection() {
  const [selectedKpi, setSelectedKpi] = useState<Kpi>(Kpi.REVENUE);
  const [ordersList, setOrdersList] = useState<OrdersList>("productGroups");

  const onKpiChange: KpiChange = (kpi, options) => {
    if (options?.ordersList) setOrdersList(options.ordersList);
    else if (kpi === Kpi.ORDERS && selectedKpi !== Kpi.ORDERS) setOrdersList("productGroups");
    setSelectedKpi(kpi);
  };

  return { selectedKpi, onKpiChange, ordersList, onOrdersListChange: setOrdersList };
}
